import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import SiteLayout from "@/components/site/SiteLayout";
import Website from "@/pages/Website";
import { NewsPage, DownloadPage, RankingPage, RegisterPage } from "@/pages/SubPages";
import Launcher from "@/pages/Launcher";
import Admin from "@/pages/Admin";
import PlayerPanel from "@/pages/PlayerPanel";
import { PlayerProvider } from "@/lib/player";

function App() {
  return (
    <BrowserRouter>
      <PlayerProvider>
      <Routes>
        <Route element={<SiteLayout />}>
          <Route path="/" element={<Website />} />
          <Route path="/aktualnosci" element={<NewsPage />} />
          <Route path="/pobierz" element={<DownloadPage />} />
          <Route path="/ranking" element={<RankingPage />} />
          <Route path="/rejestracja" element={<RegisterPage />} />
          <Route path="/panel" element={<PlayerPanel />} />
        </Route>
        <Route path="/launcher" element={<Launcher />} />
        <Route path="/adminuj" element={<Admin />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster theme="dark" position="bottom-right" toastOptions={{ classNames: { toast: "!bg-[#11141c] !text-slate-100 !border-amber-500/30", description: "!text-slate-400" } }} />
      </PlayerProvider>
    </BrowserRouter>
  );
}

export default App;
